<template>
	<div class="card">
		<div class="card-header">Konverzie</div>
		<div class="card-body pt-3 pl-3 pr-3">
			<Loading v-if="loading" class="mt-2 mb-1" />
			<data-grid :items="items" :columns="columns" :show-detail="false" v-if="!loading">
				<div class="text-lg-right" slot="purchasePrice" slot-scope="{ item }">
					<price :value="item.purchasePrice" />
				</div>
				<div class="text-lg-right" slot="sellPrice" slot-scope="{ item }">
					<price :value="item.sellPrice" />
				</div>
				<template slot="conversionRate" slot-scope="{ item }">
					{{ item.conversionRate | number(null) }}
				</template>
				<template slot="dealDate" slot-scope="{ item }">
					{{ item.dealDate | date }}
				</template>
			</data-grid>
            <Loading v-if="!loading && loadingNext"/>
		</div>
	</div>
</template>
<script>
import DataGrid from "../../../components/DataGrid";
import Price from "../../../components/price";
import Loading from "../../../components/Loading";

export default {
	name: "Conversions",
	components: {
		Loading,
		Price,
		DataGrid,
	},
	props: {
		portfolio: {
			type: String | null,
			required: false,
			default: null,
		},
	},
	watch: {
		portfolio() {
			this.page = 1;
			this.loadData();
		},
		from() {
			this.page = 1;
			this.loadData();
		},
		to() {
			this.page = 1;
			this.loadData();
		},
	},
	computed: {
		items() {
			return this.$store.state.transactions.conversions;
		},
		loading() {
			return this.$store.state.transactions.loading;
		},
        loadingNext() {
            return this.$store.state.transactions.loadingNext;
        },
		from() {
			return this.$store.state.transactions.from;
		},
		to() {
			return this.$store.state.transactions.to;
		},
	},
	mounted() {
		this.loadData();
	},
	methods: {
		loadData() {
			this.$store.dispatch("transactions/conversions", {
				page: this.page,
				append: true,
				portfolioId: this.portfolio,
				from: this.from,
				to: this.to,
			});
		},
		nextPage() {
			this.page += 1;
			this.loadData();
		},
	},
	data() {
		return {
			columns: [
				{
					name: "Dátum konverzie",
					slug: "dealDate",
				},
				{
					name: "Portfólio",
					slug: "portfolio",
				},
				{
					name: "Suma nákup",
					slug: "purchasePrice",
					thClass: "text-right",
				},
				{
					name: "Mena nákup",
					slug: "purchaseCurrency",
				},
				{
					name: "Kurz",
					slug: "conversionRate",
				},
				{
					name: "Suma predaj",
					slug: "sellPrice",
					thClass: "text-right",
				},
				{
					name: "Mena predaj",
					slug: "sellCurrency",
				},
			],
		};
	},
};
</script>

<style scoped></style>
